export const FormatLogLabel = (label: string) =>
  label
    .replace(/_/g, " ")
    .replace(/\bid\b/gi, "ID")
    .replace(/\bcpf\b/gi, "CPF")
    .replace(/\bcnpj\b/gi, "CNPJ")
    .trim();